import { Component, OnInit } from "@angular/core";

@Component({
  selector: "kl-kl-not-found",
  templateUrl: "./kl-not-found.component.html",
  styleUrls: ["./kl-not-found.component.scss"],
})
export class KlNotFoundComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
